/**
 * Capability sets API service for the deployment's configured personas.
 */

import type { CapabilitySetListResponse } from "@/generated/sdk"

import { sdk, sdkCall } from "./sdk"

export type { CapabilitySet } from "@/generated/sdk"

export const capabilitySetsApi = {
  listCapabilitySets: async (
    params: { limit?: number; nextToken?: string } = {},
  ): Promise<CapabilitySetListResponse> => {
    return sdkCall(sdk.listCapabilitySets(params))
  },
}
